/**
 * Created by filatov on 18.09.2015.
 */
import CSVPreviewSection from '../CSVPreviewSection'
import {ReportGroupingLevel} from '../../../constants'

export default function CostCSVPreviewGroupingSection(){}

CostCSVPreviewGroupingSection.prototype = new CSVPreviewSection();

CostCSVPreviewGroupingSection.prototype.init = function(firstGroupingLevel, secondGroupingLevel, thirdGroupingLevel,  countGroupingColumns, countDataColumns,countGroupingRows){
    CSVPreviewSection.prototype.init.call( this );
    this.firstGroupingLevel = firstGroupingLevel;
    this.secondGroupingLevel = secondGroupingLevel;
    this.thirdGroupingLevel = thirdGroupingLevel;
    this.countDataColumns = countDataColumns;
    this.countGroupingColumns  = countGroupingColumns;
    this.countGroupingRos = countGroupingRows;
    return this;
};

CostCSVPreviewGroupingSection.prototype.addRows = function ( tBody )
{
    for( var i = 0; i < 5; i++ )
    {
        var row = this.createRow();
        this.addGroupingLevel(row,this.firstGroupingLevel);
        if( this.secondGroupingLevel != ReportGroupingLevel.NONE )
            this.addGroupingLevel(row,this.secondGroupingLevel);
        if( this.thirdGroupingLevel != ReportGroupingLevel.NONE )
            this.addGroupingLevel( row, this.thirdGroupingLevel );

        for( var j = 0; j < this.countDataColumns; j++ )
            this.addTimeValueCell( row );
        this.addRow( tBody, row );
    }
};

CostCSVPreviewGroupingSection.prototype.addGroupingLevel = function(row, groupingLevel){
    ReportPreviewUtils.addCell( row, ReportPreviewUtils.getLevelPreviewName(groupingLevel ) );
};


// WEBPACK FOOTER //
// ./web/js/reports/preview/csv/cost/CostCSVPreviewGroupingSection.js